//der Prevent initial scroll on page load
window.addEventListener('load', () => {
  if (window.location.hash) {
    window.scrollTo(0, 0);
  }
});

// Execute function only if relevant cookie is not set with 'true'
function runUnlessCookieIsTrue(cookieName, dependent) {
  var match = document.cookie.match(new RegExp("(?:^|; )" + cookieName + "=([^;]*)"));
  if (!match || match[1] !== "true") {
    dependent();
  }
}

// Execute function only if relevant cookie is set with 'true'
function runIfCookieIsTrue(cookieName, dependent) {
  var match = document.cookie.match(new RegExp("(?:^|; )" + cookieName + "=([^;]*)"));
  if (match && match[1] === "true") {
    dependent();
  }
}

// Posthog - Added by Lydia 2.24.25
// (Originally in a <script defer> tag in Webflow; defer has no effect on inline scripts, so ordering is unchanged.)
runUnlessCookieIsTrue(
  '__cl_no_analytics',
  function() {
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug getPageViewId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

    posthog.init('phc_eYOiq6v3kInH9kjV45FJ4ZpW7pm33RvStNy28DAetO6', {
      // BKJ - 07/31/25 - set api_host to reverse proxy along with ui_host
      api_host: 'https://quills.commonlit.org',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
    })
  }
);

// Handle recipient_id query param for PostHog LJG - Added 10/23/25
runUnlessCookieIsTrue(
  '__cl_no_analytics',
  function() {

    var recipientId = new URLSearchParams(window.location.search).get('recipient');

    if (recipientId) {
      try {
        if (/^\d+$/.test(recipientId)) {
          posthog.identify(recipientId);
        }

        // Remove recipient_id from URL
        var url = new URL(window.location.href);
        url.searchParams.delete('recipient');
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        // no-op
      }
    }
  }
);

// Webflow Analyze LJG - Added 12/17/25
runUnlessCookieIsTrue(
  '__cl_no_analytics',
  function () {
    wf.ready(() => {
      console.log('before allow tracking:', wf.getUserTrackingChoice())

      wf.allowUserTracking({ activate: true });

      console.log('after allow tracking:', wf.getUserTrackingChoice())
    })
  }
);

runIfCookieIsTrue(
  '__cl_no_analytics',
  function () {
    wf.ready(() => {
      console.log('before deny tracking:', wf.getUserTrackingChoice())

      wf.denyUserTracking();

      console.log('after deny tracking:', wf.getUserTrackingChoice())
    })
  }
);
